import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { _t } from '@hip/translations';
import { getCategory } from '../core/utils';
import { RouteList } from '../routes';
import { AppointmentErrorType } from '../core/appointment';
export var useHeaderTranslations = function (options) {
    var category = useSelector(getCategory);
    var path = useRouteMatch().path;
    switch (path) {
        case RouteList.CATEGORY:
            return {
                title: _t("appointment_booking.steps.category.header.".concat(category, ".title")),
                subtitle: _t("appointment_booking.steps.category.header.".concat(category, ".subtitle")),
            };
        case RouteList.STORE:
            return {
                title: _t("appointment_booking.steps.store.header.".concat(category, ".title")),
                subtitle: _t("appointment_booking.steps.store.header.".concat(category, ".subtitle")),
            };
        case RouteList.DATETIME:
            return {
                title: _t("appointment_booking.steps.datetime.header.".concat(category, ".title")),
                subtitle: _t("appointment_booking.steps.datetime.header.".concat(category, ".subtitle"), { name: options === null || options === void 0 ? void 0 : options.storeName, phone: options === null || options === void 0 ? void 0 : options.storePhone }),
            };
        case RouteList.CONTACTS:
            return {
                title: _t("appointment_booking.steps.contacts.header.".concat(category, ".title")),
                subtitle: _t("appointment_booking.steps.contacts.header.".concat(category, ".subtitle"), { name: options === null || options === void 0 ? void 0 : options.storeName, phone: options === null || options === void 0 ? void 0 : options.storePhone }),
            };
        case "".concat(RouteList.CONFIRMATION, "/:appointmentId"):
            return {
                title: (options === null || options === void 0 ? void 0 : options.clientName)
                    ? _t("appointment_booking.steps.confirmation.header.".concat(category, ".title"), { name: options === null || options === void 0 ? void 0 : options.clientName })
                    : _t("appointment_booking.steps.confirmation.header.".concat(category, ".titleWithoutName")),
                subtitle: _t("appointment_booking.steps.confirmation.header.".concat(category, ".subtitle")),
            };
        case "".concat(RouteList.AMEND_CALENDAR, "/:appointmentId"):
        case "".concat(RouteList.AMEND, "/:appointmentId"):
            if ((options === null || options === void 0 ? void 0 : options.appointmentErrorType) ===
                AppointmentErrorType.appointmentDoNotExist) {
                return {
                    title: _t("appointment_booking.steps.amend.header.".concat(category, ".title.not_existing")),
                    subtitle: null,
                };
            }
            if ((options === null || options === void 0 ? void 0 : options.appointmentErrorType) ===
                AppointmentErrorType.appointmentWasCanceled) {
                return {
                    title: _t("appointment_booking.steps.amend.header.".concat(category, ".title.canceled")),
                    subtitle: _t("appointment_booking.steps.amend.header.".concat(category, ".subtitle.canceled")),
                };
            }
            return {
                title: _t("appointment_booking.steps.amend.header.".concat(category, ".title.regular")),
                subtitle: _t("appointment_booking.steps.amend.header.".concat(category, ".subtitle.regular")),
            };
        case "".concat(RouteList.AMEND, "/:appointmentId").concat(RouteList.SUCCESS): {
            return {
                title: _t("appointment_booking.steps.amend_success.header.".concat(category, ".title")),
                subtitle: _t("appointment_booking.steps.amend_success.header.".concat(category, ".subtitle")),
            };
        }
        default: {
            return {
                title: null,
                subtitle: null,
            };
        }
    }
};
